function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.884 17.7646L13.3647 12.2452C14.4115 10.9528 15.0417 9.30976 15.0417 7.52086C15.0417 3.37388 11.6678 0 7.52082 0C3.37384 0 0 3.37388 0 7.52086C0 11.6678 3.37388 15.0417 7.52086 15.0417C9.30976 15.0417 10.9528 14.4115 12.2452 13.3647L17.7646 18.8841C17.9192 19.0386 18.1698 19.0386 18.3244 18.8841L18.8841 18.3244C19.0386 18.1698 19.0386 17.9191 18.884 17.7646ZM7.52086 13.4584C4.24673 13.4584 1.58335 10.795 1.58335 7.52086C1.58335 4.24673 4.24673 1.58335 7.52086 1.58335C10.795 1.58335 13.4584 4.24673 13.4584 7.52086C13.4584 10.795 10.795 13.4584 7.52086 13.4584Z",
  fill: "#8D8D96"
});

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.8512f2da.svg";
export { ForwardRef as ReactComponent };